import {CLStore} from 'common/src/redux/store';
import {CompWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import {FORMAT_QUERY_KEY} from 'common/src/modules/creativeTemplates/creativeTemplates.consts';
import getUrlQueryParamValue from 'common/src/utils/urlUtils/getUrlQueryParamValue/getUrlQueryParamValue';

import getFormatComps from './getFormatComps';

export default function getActiveComp(store: CLStore): CompWithWorkingProps | null {
  const activeFormat = getUrlQueryParamValue<string>(FORMAT_QUERY_KEY);

  if (!activeFormat) {
    return null;
  }

  const comps = getFormatComps(store);
  const activeCompId = store.getState().creativeTemplatePage.formatMovies.activeCompId;

  if (!activeCompId || !comps) {
    return null;
  }

  const activeComp = comps[activeCompId];

  return activeComp || null;
}
